// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3Umtz","footer":"ModalError_footer__1o1EG"};